import { createAction, props } from '@ngrx/store';
import { Table } from './tables.reducer';

export const upsertOne = createAction('[Tables] Upsert Table', props<{ table: Table }>());
export const removeOne = createAction('[Tables] Remove Table', props<{ tableId: number }>());
export const updateOne = createAction('[Tables] Update Table', props<{ tableId: number; table: Partial<Table> }>());

export const openMixTableDetails = createAction('[Tables] openMixTableDetails', props<{ idTable: number }>());
